import { Table, Tbody, Th, Tr } from '@chakra-ui/react';
import React from 'react';

import type { AddressEpochRewardsItem } from 'types/api/address';

import { useI18n } from 'lib/i18n/context';
import { default as Thead } from 'ui/shared/TheadSticky';

import { ADDRESS_LIST_KEYS } from '../i18n';
import AddressEpochRewardsTableItem from './AddressEpochRewardsTableItem';

 type Props = {
   items: Array<AddressEpochRewardsItem>;
   isLoading?: boolean;
   top: number;
 };

const AddressEpochRewardsTable = ({ items, isLoading, top }: Props) => {
  const { t } = useI18n();

  return (
    <Table minW="1000px" style={{ tableLayout: 'auto' }}>
      <Thead top={ top }>
        <Tr>
          <Th>{ t(ADDRESS_LIST_KEYS.fields.block) }</Th>
          <Th>{ t(ADDRESS_LIST_KEYS.fields.rewardType) }</Th>
          <Th>{ t(ADDRESS_LIST_KEYS.fields.associatedAddress) }</Th>
          <Th isNumeric>{ t(ADDRESS_LIST_KEYS.fields.value) }</Th>
        </Tr>
      </Thead>
      <Tbody>
        { items.map((item, index) => {
          return (
            <AddressEpochRewardsTableItem
              key={ item.block_hash + item.type + item.account.hash + item.associated_account.hash + (isLoading ? String(index) : '') }
              item={ item }
              isLoading={ isLoading }
            />
          );
        }) }
      </Tbody>
    </Table>
  );
};

export default AddressEpochRewardsTable;
